import { curry, without, intersection, isEmpty, not, range, map } from 'ramda';

export const copyToClipboard = text => () => navigator.clipboard.writeText(text);

export const cleanUniqueId = uniqueId => {
  return uniqueId?.replace(/[^0-9]/g, '');
};

export const extractExactAge = (birthday, referenceDate) => {
  var differenceInMilisecond = Date.parse(referenceDate) || Date.now() - Date.parse(birthday);

  var years = Math.floor(differenceInMilisecond / 31536000000);
  var days = Math.floor((differenceInMilisecond % 31536000000) / 86400000);
  var months = Math.floor(days / 30);

  days = days % 30;

  if (isNaN(years) || isNaN(months) || isNaN(days)) {
    return {};
  } else {
    return {
      years,
      months,
      days
    };
  }
};

// valueOrDefault :: a -> a -> a
export const valueOrDefault = curry(($default, value) => value ?? $default);

// withoutItem :: a -> [a] -> [a]
export const withoutItem = curry((x, xs) => xs |> without([x]));

export const intersect = (needed = [], received = []) => intersection(needed, received) |> isEmpty |> not;

export const isNullOrWhitespace = str => !str || /^\s*$/.test(str);

// transformToDate :: String -> Date
export const transformToDate = str => new Date(str);

// addDays :: Int -> Date -> Date
export const addDays = curry((days, date) => {
  let localMutable = new Date(date);
  localMutable.setDate(localMutable.getDate() + days);
  return localMutable;
});

// addOneDay :: Date -> Date
export const addOneDay = addDays(1);

// addMilliseconds :: Int -> Date -> Date
export const addMilliseconds = curry((milliseconds, date) => new Date(date.getTime() + milliseconds));

// subtractOneMillisecond :: Date -> Date
export const subtractOneMillisecond = addMilliseconds(-1);

//transform graphics data
export const transformedData = (graphic, t) => {
  return graphic?.map(graphic => ({
    ...graphic,
    data:
      range(1, 13)
      |> map(d => {
        const elem = (graphic?.data |> find(elem => elem?.x === d)) || { y: null, x: d };
        return { ...elem, x: t(`Dashboard.Months.${elem.x}`) };
      })
  }));
};

export const getOidcConfigName = () => {
  const tid = 'config_show_access_token';
  return tid;
};

export function camelize(str) {
  if (!str) return '';
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

export function hexToHSL(H) {
  // Convert hex to RGB first
  let r = 0,
    g = 0,
    b = 0;
  if (H.length == 4) {
    r = '0x' + H[1] + H[1];
    g = '0x' + H[2] + H[2];
    b = '0x' + H[3] + H[3];
  } else if (H.length == 7) {
    r = '0x' + H[1] + H[2];
    g = '0x' + H[3] + H[4];
    b = '0x' + H[5] + H[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;

  if (delta == 0) h = 0;
  else if (cmax == r) h = ((g - b) / delta) % 6;
  else if (cmax == g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return 'hsl(' + h + ',' + s + '%,' + l + '%)';
}

const byPropertiesOf = (fields, direction) => (obj1, obj2) => {
  let sortOrder = direction === 'asc' ? 1 : -1;
  let result = 0;
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    if (obj1[field] < obj2[field]) {
      result = -1;
      break;
    }
    if (obj1[field] > obj2[field]) {
      result = 1;
      break;
    }
    // sort the rest ascending if the primary field is equal
    sortOrder = 1;
  }
  return result * sortOrder;
};

export const sortBy = (array, fields, direction) => {
  array.sort(byPropertiesOf(fields, direction));
};
